/**
 * The design's data files are plain scripts that set a window global. Importing one runs
 * it; this reads the value and removes the global again, so nothing else can come to
 * depend on it. A missing file gives the fallback, never an error.
 */
export function takeWindowData<T>(key: string, fallback: T): T {
  const w = globalThis as unknown as Record<string, unknown>;
  const v = w[key];
  try {
    delete w[key];
  } catch {
    /* a non-configurable global stays; the value is still ours */
  }
  return (v === undefined ? fallback : (v as T));
}
